const accountManagement = [
  {
    tabName: "Sales",
    page: [],
    path: "/account-management/sales",
    authority: "PORTAL",
    rolePermission: "ACCOUNT_SALES",
  },
  {
    tabName: "Referrer",
    page: [],
    path: "/account-management/referrer",
    authority: "PORTAL",
    rolePermission: "ACCOUNT_REFERRER",
  },
  {
    tabName: "Service Integrator",
    page: [],
    path: "/account-management/service-integrator",
    authority: "PORTAL",
    rolePermission: "ACCOUNT_SYSTEM_INTEGRATOR",
  },
  {
    tabName: "Maintenance Party",
    page: [],
    path: "/account-management/maintenance-party",
    authority: "PORTAL",
    rolePermission: "ACCOUNT_MAINTENANCE_PARTY",
  },
];

export default accountManagement;
